import React, { memo, useMemo } from 'react'
import IconHSBC from '@/components/modals/CheckoutPromotionModal/PromosBadges/IconHSBC'
import IconOCBC from '@/components/modals/CheckoutPromotionModal/PromosBadges/IconOCBC'
import IconDBS from '@/components/modals/CheckoutPromotionModal/PromosBadges/IconDBS'
import IconPOSB from '@/components/modals/CheckoutPromotionModal/PromosBadges/IconPOSB'
import IconUOB from '@/components/modals/CheckoutPromotionModal/PromosBadges/IconUOB'
import IconStandardChartered from '@/components/modals/CheckoutPromotionModal/PromosBadges/IconStandardChartered'
import IconInsider from '@/components/modals/CheckoutPromotionModal/PromosBadges/IconInsider'
import IconAmex from '@/components/icons/payment/IconAmex'
import { promotionAppliedOnTypes } from '@/utils/promotion'
import IconDelivery from '@/components/icons/IconDelivery'
import IconPickup from '@/components/icons/IconPickup'
import IconFirstTime from '@/components/modals/CheckoutPromotionModal/PromosBadges/IconFirstTime'
import IconNewsletter from '@/components/modals/CheckoutPromotionModal/PromosBadges/IconNewsletter'
import IconLoyalCustomer from '@/components/icons/IconLoyalCustomer'
import { cn } from 'oddle-shop-monorepo.design-system'

export function DefaultPromoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 14 13"
      fill="none"
      className="!h-[unset] !w-full"
    >
      <path
        d="M6.79269 12.8761C6.5342 12.8761 6.28793 12.8301 6.05388 12.738C5.8197 12.6459 5.61222 12.5129 5.43144 12.339C5.07201 12.0011 4.76377 11.78 4.50671 11.6756C4.24954 11.5713 3.86384 11.5192 3.3496 11.5192C2.81476 11.5192 2.36017 11.3409 1.98585 10.9843C1.61153 10.6278 1.42437 10.1948 1.42437 9.6853C1.42437 9.1999 1.36943 8.83347 1.25955 8.586C1.14967 8.33854 0.917702 8.04396 0.563639 7.70228C0.379398 7.52678 0.23937 7.32773 0.143555 7.10512C0.0477397 6.88251 -0.000167847 6.64981 -0.000167847 6.40699C-0.000167847 6.16418 0.0477397 5.93102 0.143555 5.7075C0.23937 5.48399 0.379398 5.28448 0.563639 5.10899C0.917702 4.76969 1.14967 4.47721 1.25955 4.23156C1.36943 3.9858 1.42437 3.61726 1.42437 3.12596C1.42437 2.6165 1.61153 2.18349 1.98585 1.82694C2.36017 1.47038 2.81476 1.2921 3.3496 1.2921C3.85919 1.2921 4.24388 1.23977 4.50368 1.13511C4.76347 1.03045 5.07273 0.809486 5.43144 0.472228C5.61258 0.29832 5.82036 0.165335 6.05477 0.0732735C6.28918 -0.0187886 6.53426 -0.0648193 6.79001 -0.0648193C7.04575 -0.0648193 7.29095 -0.019186 7.5256 0.0720814C7.76025 0.163349 7.9697 0.296731 8.15394 0.472228C8.51015 0.809486 8.8172 1.03045 9.07509 1.13511C9.3331 1.23977 9.71999 1.2921 10.2358 1.2921C10.7706 1.2921 11.2252 1.47038 11.5995 1.82694C11.9739 2.18349 12.161 2.6165 12.161 3.12596C12.161 3.61136 12.216 3.97779 12.3258 4.22526C12.4357 4.47273 12.6677 4.7673 13.0217 5.10899C13.206 5.28448 13.346 5.48354 13.4418 5.70614C13.5376 5.92875 13.5855 6.16146 13.5855 6.40427C13.5855 6.64708 13.5376 6.88024 13.4418 7.10376C13.346 7.32727 13.206 7.52678 13.0217 7.70228C12.667 8.04464 12.4348 8.33825 12.3253 8.58311C12.2158 8.82808 12.161 9.19547 12.161 9.6853C12.161 10.1948 11.9739 10.6278 11.5995 10.9843C11.2252 11.3409 10.7706 11.5192 10.2358 11.5192C9.72619 11.5192 9.3415 11.5715 9.0817 11.6762C8.82191 11.7808 8.51265 12.0018 8.15394 12.339C7.97316 12.5129 7.76568 12.6459 7.5315 12.738C7.29745 12.8301 7.05118 12.8761 6.79269 12.8761ZM6.79358 11.8544C6.90668 11.8544 7.01709 11.8324 7.12482 11.7884C7.23256 11.7442 7.32307 11.6872 7.39636 11.6174C7.84826 11.1825 8.27532 10.8872 8.67753 10.7313C9.07962 10.5754 9.59903 10.4975 10.2358 10.4975C10.4773 10.4975 10.6799 10.4197 10.8434 10.2641C11.0068 10.1083 11.0885 9.9154 11.0885 9.6853C11.0885 9.07503 11.1703 8.58038 11.3339 8.20135C11.4975 7.82243 11.8053 7.41553 12.2572 6.98065C12.4277 6.81821 12.513 6.62653 12.513 6.40563C12.513 6.18473 12.43 5.99521 12.2642 5.83708C11.8076 5.40231 11.4975 4.99337 11.3339 4.61025C11.1703 4.22725 11.0885 3.73248 11.0885 3.12596C11.0885 2.89587 11.0068 2.70294 10.8434 2.5472C10.6799 2.39157 10.4773 2.31375 10.2358 2.31375C9.58843 2.31375 9.06663 2.2369 8.67038 2.0832C8.27413 1.92939 7.84719 1.63515 7.38957 1.20049C7.31616 1.13057 7.22558 1.0725 7.11785 1.0263C7.01012 0.979988 6.90173 0.956831 6.79269 0.956831C6.68365 0.956831 6.57413 0.980499 6.46413 1.02784C6.35401 1.07529 6.26231 1.13284 6.18902 1.20049C5.73712 1.63095 5.31006 1.92411 4.90785 2.07997C4.50576 2.23582 3.98635 2.31375 3.3496 2.31375C3.10804 2.31375 2.90551 2.39157 2.742 2.5472C2.57861 2.70294 2.49692 2.89587 2.49692 3.12596C2.49692 3.74066 2.41511 4.23746 2.25149 4.61638C2.08786 4.99541 1.77777 5.40231 1.32122 5.83708C1.15533 5.99521 1.07239 6.18473 1.07239 6.40563C1.07239 6.62653 1.15533 6.81821 1.32122 6.98065C1.77777 7.41553 2.08786 7.82311 2.25149 8.20339C2.41511 8.58368 2.49692 9.07764 2.49692 9.6853C2.49692 9.9154 2.57861 10.1083 2.742 10.2641C2.90551 10.4197 3.10804 10.4975 3.3496 10.4975C3.9954 10.4975 4.51595 10.5754 4.91125 10.7313C5.30654 10.8872 5.73473 11.1825 6.19581 11.6174C6.26922 11.6872 6.3589 11.7442 6.46484 11.7884C6.57091 11.8324 6.68049 11.8544 6.79358 11.8544ZM8.53345 8.90084C8.78014 8.90084 8.98827 8.82007 9.15786 8.65854C9.32744 8.49701 9.41223 8.29875 9.41223 8.06377C9.41223 7.82868 9.32744 7.62889 9.15786 7.4644C8.98827 7.29992 8.78014 7.21767 8.53345 7.21767C8.28664 7.21767 8.0769 7.29992 7.90421 7.4644C7.73153 7.62889 7.64519 7.82868 7.64519 8.06377C7.64519 8.29875 7.73153 8.49701 7.90421 8.65854C8.0769 8.82007 8.28664 8.90084 8.53345 8.90084ZM5.01743 8.80787L9.31463 4.72127L8.56098 4.00339L4.27075 8.09663L5.01743 8.80787ZM5.05193 5.59359C5.29874 5.59359 5.50848 5.51135 5.68116 5.34686C5.85385 5.18238 5.94019 4.98259 5.94019 4.74749C5.94019 4.51251 5.85385 4.31426 5.68116 4.15272C5.50848 3.99119 5.29874 3.91042 5.05193 3.91042C4.80524 3.91042 4.59711 3.99119 4.42752 4.15272C4.25794 4.31426 4.17315 4.51251 4.17315 4.74749C4.17315 4.98259 4.25794 5.18238 4.42752 5.34686C4.59711 5.51135 4.80524 5.59359 5.05193 5.59359Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const getBadge = (promotion: any) => {
  // Check appliedOn first (fastest check)
  if (promotion.appliedOn === promotionAppliedOnTypes.delivery) {
    return 'delivery'
  }

  if (promotion.appliedOn === promotionAppliedOnTypes.pickup) {
    return 'pickup'
  }

  // Check specific fields instead of JSON.stringify
  const name = (promotion.name || promotion.metadata?.title || '').toLowerCase()
  const description = (
    promotion.description ||
    promotion.metadata?.description ||
    ''
  ).toLowerCase()
  const promoCode = (promotion.promoCode || '').toLowerCase()

  // Combine strings once
  const searchText = `${name} ${description} ${promoCode}`

  if (
    searchText.includes('first time') ||
    searchText.includes('first-time') ||
    searchText.includes('firsttime')
  ) {
    return 'firstTime'
  }

  if (searchText.includes('newsletter')) {
    return 'newsletter'
  }

  if (searchText.includes('insider')) return 'insider'
  if (searchText.includes('master')) return 'master'
  if (searchText.includes('visa')) return 'visa'
  if (searchText.includes('hsbc')) return 'hsbc'
  if (searchText.includes('ocbc')) return 'ocbc'
  if (searchText.includes('dbs')) return 'dbs'
  if (searchText.includes('posb')) return 'posb'
  if (searchText.includes('uob')) return 'uob'
  if (searchText.includes('chartered')) return 'chartered'
  if (searchText.includes('loyal')) return 'loyal'
  if (searchText.includes('american') || searchText.includes('amex'))
    return 'amex'

  return null
}

// Badge roots are <span>, not <div>: StoreOrderSummary renders this inside
// Row text slots whose wrapper is a <p> (RowText/RowBaseText), and a <div>
// inside <p> is invalid HTML — the browser reparents it while parsing and
// hydration fails. Every root carries an explicit `flex` class, so the
// rendering is identical to the old divs.
const PromosBadges = memo(
  ({
    promotion,
    className,
    isVoucher,
    fill,
  }: {
    promotion: any
    className?: string
    isVoucher?: boolean
    fill?: string
  }) => {
    const badge = useMemo(() => getBadge(promotion), [promotion])

    if (!promotion) return null

    if (badge === 'insider')
      return (
        <span
          className={cn(
            'text-button-text flex aspect-square h-6 w-6 items-center justify-center gap-1 rounded-lg border border-solid md:h-10 md:w-10 md:rounded-lg',
            className,
          )}
        >
          <IconInsider className="!h-[unset] !w-full" />
        </span>
      )

    if (badge === 'firstTime') {
      return (
        <span
          className={cn(
            'text-button border-button flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid bg-transparent p-[1.5px] md:h-10 md:w-10 md:rounded-lg md:p-1',
            className,
          )}
        >
          <IconFirstTime className="!h-[unset] !w-full" />
        </span>
      )
    }

    if (badge === 'newsletter') {
      return (
        <span
          className={cn(
            'text-button border-button flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid bg-transparent p-[1.5px] md:h-10 md:w-10 md:rounded-lg md:p-1',
            className,
          )}
        >
          <IconNewsletter className="!h-[unset] !w-full" />
        </span>
      )
    }

    if (badge === 'delivery') {
      return (
        <span
          className={cn(
            'text-button border-button flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid bg-transparent p-[1.5px] md:h-10 md:w-10 md:rounded-lg md:p-1',
            className,
          )}
        >
          <IconDelivery className="!h-[unset] !w-full" />
        </span>
      )
    }

    if (badge === 'pickup') {
      return (
        <span
          className={cn(
            'text-button border-button flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid bg-transparent p-[1.5px] md:h-10 md:w-10 md:rounded-lg md:p-1',
            className,
          )}
        >
          <IconPickup className="!h-[unset] !w-full" />
        </span>
      )
    }

    if (badge === 'loyal') {
      return (
        <span
          className={cn(
            'text-button border-button flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid bg-transparent p-[1.5px] md:h-10 md:w-10 md:rounded-lg md:p-1',
            className,
          )}
        >
          <IconLoyalCustomer className="!h-[unset] !w-full" />
        </span>
      )
    }

    if (badge === 'master')
      return (
        <span
          className={cn(
            'text-button-text border-lines-and-borders flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid bg-white p-[1.5px] md:h-10 md:w-10 md:rounded-lg',
            className,
          )}
        >
          <svg
            className="!h-[unset] !w-full"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 17 11"
            fill="none"
          >
            <g clip-path="url(#clip0_3846_8249)">
              <path
                d="M10.5669 1.07617H5.72168V8.98977H10.5669V1.07617Z"
                fill="#FF5F00"
              />
              <path
                d="M6.22096 5.03375C6.22036 4.27174 6.3931 3.51958 6.72611 2.83419C7.05912 2.14879 7.54367 1.54813 8.1431 1.07765C7.40068 0.494192 6.50909 0.131373 5.57023 0.0306621C4.63136 -0.0700491 3.68311 0.0954104 2.83383 0.50813C1.98455 0.92085 1.26853 1.56418 0.767578 2.36459C0.266631 3.165 0.000976563 4.0902 0.000976562 5.03445C0.000976562 5.9787 0.266631 6.9039 0.767578 7.70431C1.26853 8.50472 1.98455 9.14805 2.83383 9.56077C3.68311 9.97349 4.63136 10.139 5.57023 10.0382C6.50909 9.93753 7.40068 9.57471 8.1431 8.99125C7.54349 8.52063 7.05882 7.91974 6.7258 7.23409C6.39279 6.54844 6.22015 5.796 6.22096 5.03375Z"
                fill="#EB001B"
              />
              <path
                d="M16.2854 5.03378C16.2854 5.9781 16.0197 6.90336 15.5187 7.7038C15.0176 8.50424 14.3015 9.14755 13.4521 9.56022C12.6027 9.97288 11.6544 10.1382 10.7155 10.0374C9.77654 9.93652 8.88494 9.57352 8.14258 8.98988C8.74177 8.51898 9.22618 7.91815 9.55928 7.23272C9.89237 6.54729 10.0655 5.79516 10.0655 5.03308C10.0655 4.271 9.89237 3.51887 9.55928 2.83344C9.22618 2.14801 8.74177 1.54718 8.14258 1.07628C8.88494 0.492639 9.77654 0.129643 10.7155 0.0287875C11.6544 -0.0720684 12.6027 0.0932846 13.4521 0.505946C14.3015 0.918607 15.0176 1.56192 15.5187 2.36236C16.0197 3.1628 16.2854 4.08806 16.2854 5.03238V5.03378Z"
                fill="#F79E1B"
              />
              <path
                d="M10.0647 5.03473C10.0653 4.27272 9.89258 3.52056 9.55957 2.83516C9.22656 2.14977 8.742 1.54911 8.14258 1.07863C8.885 0.495169 9.77659 0.13235 10.7155 0.0316387C11.6543 -0.0690726 12.6026 0.0963869 13.4519 0.509107C14.3011 0.921826 15.0172 1.56516 15.5181 2.36557C16.0191 3.16598 16.2847 4.09118 16.2847 5.03543C16.2847 5.97968 16.0191 6.90488 15.5181 7.70529C15.0172 8.5057 14.3011 9.14903 13.4519 9.56175C12.6026 9.97447 11.6543 10.1399 10.7155 10.0392C9.77659 9.93851 8.885 9.57569 8.14258 8.99223C8.74219 8.5216 9.22686 7.92072 9.55988 7.23506C9.89289 6.54941 10.0655 5.79697 10.0647 5.03473Z"
                fill="#F79E1B"
              />
            </g>
            <defs>
              <clipPath id="clip0_3846_8249">
                <rect width="16.2857" height="10.0678" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
      )

    if (badge === 'visa')
      return (
        <span
          className={cn(
            'text-button-text border-lines-and-borders flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid bg-white p-[1.5px] md:h-10 md:w-10 md:rounded-lg',
            className,
          )}
        >
          <svg
            className="!h-[unset] !w-full"
            viewBox="0 0 17 6"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_4717_10675"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="17"
              height="6"
            >
              <path
                d="M8.75222 1.7868C8.74257 2.56534 9.43063 2.99982 9.94896 3.25812C10.4815 3.52318 10.6604 3.69313 10.6584 3.93012C10.6543 4.29288 10.2335 4.45296 9.8397 4.45919C9.15266 4.47011 8.75323 4.2695 8.43563 4.11774L8.18815 5.30218C8.50677 5.45238 9.09676 5.58335 9.7086 5.58907C11.1447 5.58907 12.0843 4.86406 12.0894 3.7399C12.095 2.31327 10.1599 2.23428 10.1731 1.59658C10.1776 1.40324 10.358 1.19692 10.7534 1.14442C10.949 1.11792 11.4892 1.09765 12.1016 1.38609L12.3419 0.240111C12.0126 0.117457 11.5893 0 11.0624 0C9.71063 0 8.75984 0.734884 8.75222 1.7868ZM14.6516 0.0987468C14.3894 0.0987468 14.1683 0.255183 14.0697 0.495293L12.0182 5.50487H13.4533L13.7389 4.69775H15.4926L15.6583 5.50487H16.9231L15.8193 0.0987468H14.6516ZM14.8523 1.55916L15.2665 3.58918H14.1322L14.8523 1.55916ZM7.01224 0.0987468L5.88106 5.50487H7.24854L8.37922 0.0987468H7.01224ZM4.98922 0.0987468L3.56583 3.77836L2.99008 0.64965C2.92249 0.300398 2.6557 0.0987468 2.35944 0.0987468H0.0325257L0 0.255702C0.47768 0.361725 1.02041 0.532713 1.34919 0.715655C1.55043 0.827394 1.60785 0.925101 1.67391 1.19068L2.76445 5.50487H4.20968L6.42531 0.0987468H4.98922Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_4717_10675)">
              <path
                d="M-1.77246 0.667801L14.9018 -5.61249L18.6951 4.92205L2.02103 11.2023"
                fill="url(#paint0_linear_4717_10675)"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_4717_10675"
                x1="1.53267"
                y1="5.4195"
                x2="15.8705"
                y2="0.256449"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#222357" />
                <stop offset="1" stop-color="#254AA5" />
              </linearGradient>
            </defs>
          </svg>
        </span>
      )

    if (badge === 'hsbc')
      return (
        <span
          className={cn(
            'text-button-text border-lines-and-borders flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid bg-white p-[1.5px] md:h-10 md:w-10 md:rounded-lg',
            className,
          )}
        >
          <IconHSBC className="!h-[unset] !w-full" />
        </span>
      )

    if (badge === 'ocbc')
      return (
        <span
          className={cn(
            'text-button-text border-lines-and-borders flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid bg-white p-[1.5px] md:h-10 md:w-10 md:rounded-lg',
            className,
          )}
        >
          <IconOCBC className="!h-[unset] !w-full" />
        </span>
      )

    if (badge === 'dbs')
      return (
        <span
          className={cn(
            'text-button-text border-lines-and-borders flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid bg-white p-[1.5px] md:h-10 md:w-10 md:rounded-lg',
            className,
          )}
        >
          <IconDBS className="!h-[unset] !w-full" />
        </span>
      )

    if (badge === 'posb')
      return (
        <span
          className={cn(
            'text-button-text border-lines-and-borders flex aspect-square h-6 w-6 items-center justify-center gap-1 rounded-lg border border-solid bg-white p-[1.5px] md:h-10 md:w-10 md:rounded-lg',
            className,
          )}
        >
          <IconDBS className="!h-[unset] !w-full" />
          <IconPOSB className="!h-[unset] !w-full" />
        </span>
      )

    if (badge === 'uob')
      return (
        <span
          className={cn(
            'text-button-text border-lines-and-borders flex aspect-square h-6 w-6 items-center justify-center gap-1 rounded-lg border border-solid bg-white p-[1.5px] md:h-10 md:w-10 md:rounded-lg',
            className,
          )}
        >
          <IconUOB className="!h-[unset] !w-full" />
        </span>
      )

    if (badge === 'chartered')
      return (
        <span
          className={cn(
            'text-button-text border-lines-and-borders flex aspect-square h-6 w-6 items-center justify-center gap-1 rounded-lg border border-solid bg-white p-[1.5px] md:h-10 md:w-10 md:rounded-lg',
            className,
          )}
        >
          <IconStandardChartered className="!h-[unset] !w-full" />
        </span>
      )

    if (badge === 'amex')
      return (
        <span
          className={cn(
            'text-button-text border-lines-and-borders flex aspect-square h-6 w-6 items-center justify-center gap-1 rounded-lg border border-solid bg-white p-[1.5px] md:h-10 md:w-10 md:rounded-lg',
            className,
          )}
        >
          <IconAmex className="!h-[unset] !w-full" />
        </span>
      )

    if (isVoucher) {
      return (
        <span
          className={cn(
            'text-button flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid border-[#D9D9D952] bg-transparent md:h-10 md:w-10 md:rounded-lg',
            className,
          )}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className="h-full w-full"
          >
            <path
              d="M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z"
              fill={fill || 'white'}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.5155 16.6688L16.6655 13.5188C17.4752 12.71 17.9305 11.6125 17.9311 10.468C17.9318 9.32341 17.4777 8.22548 16.6688 7.41571C15.86 6.60594 14.7625 6.15066 13.618 6.15003C12.4734 6.14939 11.3755 6.60346 10.5657 7.41234L7.41571 10.5623C6.60594 11.3712 6.15066 12.4686 6.15003 13.6132C6.14939 14.7578 6.60346 15.8557 7.41234 16.6655C8.22121 17.4752 9.31864 17.9305 10.4632 17.9311C11.6078 17.9318 12.7057 17.4777 13.5155 16.6688ZM14.2143 7.46235C14.8105 7.58089 15.3581 7.87356 15.788 8.30334C16.0737 8.58859 16.3004 8.92739 16.455 9.30034C16.6097 9.6733 16.6893 10.0731 16.6893 10.4768C16.6893 10.8806 16.6097 11.2804 16.455 11.6533C16.3004 12.0263 16.0737 12.3651 15.788 12.6503C15.3581 13.0801 14.8105 13.3728 14.2143 13.4913C13.6181 13.6099 13.0001 13.549 12.4386 13.3163C11.877 13.0837 11.397 12.6897 11.0593 12.1843C10.7216 11.6789 10.5414 11.0847 10.5414 10.4768C10.5414 9.86898 10.7216 9.27477 11.0593 8.76935C11.397 8.26393 11.877 7.86999 12.4386 7.63735C13.0001 7.40471 13.6181 7.34381 14.2143 7.46235ZM14.6 11.4533C14.4051 11.6479 14.1569 11.7804 13.8868 11.834C13.6167 11.8875 13.3368 11.8599 13.0824 11.7544C12.828 11.6489 12.6106 11.4704 12.4577 11.2414C12.3047 11.0124 12.2231 10.7432 12.2231 10.4678C12.2231 10.1925 12.3047 9.92326 12.4577 9.69426C12.6106 9.46527 12.828 9.28676 13.0824 9.18129C13.3368 9.07582 13.6167 9.04812 13.8868 9.10171C14.1569 9.15529 14.4051 9.28775 14.6 9.48234C14.7295 9.61169 14.8323 9.76531 14.9024 9.93441C14.9725 10.1035 15.0086 10.2848 15.0086 10.4678C15.0086 10.6509 14.9725 10.8322 14.9024 11.0013C14.8323 11.1704 14.7295 11.324 14.6 11.4533Z"
              fill="#3D0099"
            />
          </svg>
        </span>
      )
    }

    return (
      <span
        className={cn(
          'text-button border-button flex aspect-square h-6 w-6 items-center justify-center rounded-lg border border-solid bg-transparent p-[1.5px] md:h-10 md:w-10 md:rounded-lg md:p-1',
          className,
        )}
      >
        <DefaultPromoIcon />
      </span>
    )
  },
)

PromosBadges.displayName = 'PromosBadges'

export default PromosBadges
